import {
  getProfileThemeFontStylesheetUrl,
  resolveProfileThemeFontName,
} from "../constants/profileThemeFonts";

// Adds the Google Fonts stylesheet for one booking-page font to <head>, once.
// Pages call it for the font they show, so a visitor downloads that font and
// not every one a pro could pick. The link stays after the page unmounts: the
// browser has already fetched it, and a pro flicking through fonts in the
// editor shouldn't refetch one they tried a moment ago.
export const loadProfileThemeFont = (fontName) => {
  if (typeof document === "undefined") return;
  const href = getProfileThemeFontStylesheetUrl(fontName);
  if (!href) return;

  const name = resolveProfileThemeFontName(fontName);
  const alreadyLoaded = Array.from(
    document.head.querySelectorAll("link[data-profile-theme-font]")
  ).some((link) => link.getAttribute("data-profile-theme-font") === name);
  if (alreadyLoaded) return;

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.setAttribute("data-profile-theme-font", name);
  document.head.appendChild(link);
};

export default loadProfileThemeFont;
